import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'
  
  },
  {
    title: 'Material'
  
  }
];

@Component({
  selector: 'page-material',
  templateUrl: './material.html',
  styleUrls: ['./material.scss']
})

export class PageMaterial implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  supplierCtrl: FormControl;
  productCtrl:FormControl;
  filteredSuppliers: any;
  filteredProducts:any;
  basePath:any=environment.sysPath;

  columns = [
    //{ prop: 'Item' },
    { name: 'tm_id' },
    { name: 'tm_part_no' },
    { name: 'tm_part_name' },
    { name: 'tm_master' },
    { name: 'tm_stock_max' },
    { name: 'tm_stock_min' },
    { name: 'tm_unit' },
    { name: 'tm_color' },
    { name: 'tm_slit' },
    { name: 'tb2_supplier_tb2_id' },
    { name: 'tb46_material_type_tb46_id' }
  ];
  
  rows = [];
  temp = [];
  model=[];
  productModels=[];
  suppliers = [];
  key:any="";keypart:any="";
  fetchSupplier=[];
  loadingIndicator: boolean = true;
  sysPathPrint:String=environment.sysPath+"/api/material-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/material-list-export.php";
  constructor( private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
   this.getDataStart();
    this.getSupplier();
    this.getProduct();

   // console.log('-------this.filteredStates-----',this.filteredStates);
    
    this._sharedService.emitChange(this.pageTitle);
  }

  getDataStart(){
    this.httpservice.fetchget('getJSON_material.php?key='+this.key+'&keypart='+this.keypart,(data)=>{
      this.temp = [...data];
      this.rows = data;
      this.loadingIndicator = false;
    });
  }
  getSupplier(){
    this.httpservice.fetchget('getJSON_supplier_name.php?',(data)=>{
      this.suppliers = data.map(function (val) {
        return [val.tb2_company_shortname]
      });
    });

    this.supplierCtrl = new FormControl();
    this.filteredSuppliers = this.supplierCtrl.valueChanges
    .startWith(null)
    .map(val=>{
      if(isArray(val)){
        this.key=val[0];
      }else{
        this.key=val;
      }
      console.log('------val------',this.key);
      return val ? this.suppliers.filter((s) => new RegExp(val, 'gi').test(s)) : this.suppliers;
    });
  }

  getProduct(){
    this.httpservice.fetchget('getJSON_material.php?',(productModel) => {
      this.productModels = productModel.map(function (val) {
        return [val.tm_part_no]
      });
      console.log('------this.product------', this.productModels);
    });
    this.productCtrl = new FormControl();
    this.filteredProducts = this.productCtrl.valueChanges
    .startWith(null)
    .map(val => {

      if (isArray(val)) {
        this.keypart = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.keypart = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.productModels.filter((s) => new RegExp(val, 'gi').test(s)) : this.productModels;
    });
  }
  disableMaterial(tm_id:string){
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/disableMaterial.php?tm_id='+tm_id);

    req.onload = () => {
      console.log('---delect status ---',JSON.parse(req.response),tm_id);
      //JSON.parse(req.response);
    };
    req.send();
    for(let i=0;i<2;i++){
      this.search();
    }
  }
  edit(tm_id:string){
    console.log('----ID----',tm_id);
    this.router.navigateByUrl('default-layout/material-form-edit/'+tm_id);
  }
search(){  
  this.httpservice.fetchget('getJSON_material.php?key='+this.key+'&keypart='+this.keypart,(data)=>{
    this.temp = [...data];
    this.rows = data;
    this.productCtrl.reset();
    this.supplierCtrl.reset();
    this.key="";
    this.keypart="";
  });

  }
  ngOnInit() {
  }
    pagelink(item){
      alert(item);
    }
  
    openDialog(tp_id:string) {
    
    let dialogRef = this.dialog.open(MaterailDiableDialog);
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      
      if(result==='1'){
        this.disableMaterial(tp_id);
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }

    });
  }

    updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      return d.tm_part_no.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
  }
  updateFilter_(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      return d.tm_type.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
  }
}
//dialog
@Component({
  selector: 'material-dialog',
  templateUrl: 'material-dialog.html',
})
export class MaterailDiableDialog {
  jazzMessage = 'Jazzy jazz jazz';
  constructor(public dialogRef: MdDialogRef<MaterailDiableDialog>) {}
}




// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/material/material.ts